import React from "react";
import altaRotacion from '../assets/alta-rotacion_web2.png'; // Adjust the path as necessary
import procaComprension from '../assets/no-entiendes-procesos_web2.png'; // Adjust the path as necessary
import altoCosto from '../assets/alto-costo-vinculacion_web2.png'; // Adjust the path as necessary
import erroresPorFaltaDeExperiencia from '../assets/errores-falta-experiencia_web2.png'; // Adjust the path as necessary

function WhatItSolves() {
    return (
        <div className="container what-it-solves py-5">
            <h2 className="section-title">¿Qué solucionamos?</h2>
            <div className="row text-center" style={{padding:'3rem'}}>
                <div className="col-md-3 problem-icon">
                    <img src={altaRotacion} alt="Reduce la rotación del personal" />
                    <p>Reduce la rotación del personal</p>
                </div>
                <div className="col-md-3 problem-icon">
                    <img src={procaComprension} alt="Disminuye la perdida de informacion" />
                    <p>Disminuye la perdida de información</p>
                </div>
                <div className="col-md-3 problem-icon">
                    <img src={altoCosto} alt="Alto costo de vinculación" />
                    <p>Reduce costos de vinculación</p>
                </div>
                <div className="col-md-3 problem-icon">
                    <img src={erroresPorFaltaDeExperiencia} alt="Errores por falta de experiencia" />
                    <p>Evita errores operativos desde el primer día.</p>
                </div>
            </div>
        </div>
    );
}

export default WhatItSolves;